/* useActivityLogger — fire-and-forget engagement tracking.
   Captures route changes + key button clicks. Privacy-conscious: never logs form input.
*/
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import api from "../api";

const post = (action, route, detail) => {
  // Don't await — engagement logging must never block the UI.
  api.post("/activity", { action, route, detail }).catch(() => { /* ignore */ });
};

export function useRouteTracker() {
  const location = useLocation();
  const lastRef = useRef("");
  useEffect(() => {
    if (lastRef.current === location.pathname) return;
    lastRef.current = location.pathname;
    post("route", location.pathname, {});
  }, [location.pathname]);
}

export function trackClick(label, detail = {}) {
  post("click", window.location.pathname, { label, ...detail });
}

export function trackDownload(label, detail = {}) {
  post("download", window.location.pathname, { label, ...detail });
}

export function trackAiCall(label, detail = {}) {
  post("ai_call", window.location.pathname, { label, ...detail });
}
